<template>
  <component
    ref="rootEl"
    :is="as"
    class="sb-breadcrumbs__link"
    :aria-disabled="disabled || undefined"
    :aria-current="current"
    tabindex="0"
    :href="isLink ? href : undefined"
    :target="isLink ? target : undefined"
    :to="isRouterLink ? to : undefined"
    :aria-label="!truncated && label"
    v-bind="$attrs"
    v-tooltip="
      truncated && {
        position: 'bottom',
        label: label,
      }
    "
    @click="(event: MouseEvent) => handleItemSelect(event, itemId)"
    @keydown.enter="(event: KeyboardEvent) => handleItemSelect(event, itemId)"
    @keydown.space="(event: KeyboardEvent) => handleItemSelect(event, itemId)"
  >
    {{ label }}
  </component>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import type { BreadcrumbLinkType } from './types'
import vTooltip from '../../directives/tooltip'

const emit = defineEmits<{
  (e: 'select-item', label: string): void
}>()

const props = withDefaults(
  defineProps<{
    as?: BreadcrumbLinkType
    itemId: string | number
    label?: string
    target?: string
    disabled?: boolean
    href?: string
    to?: string | Record<string, unknown> | null
    current?: string
    truncated?: boolean
    disableLinkNavigation?: boolean
  }>(),
  {
    as: 'a',
    itemId: '',
    label: '',
    target: undefined,
    disabled: false,
    href: '',
    to: null,
    current: undefined,
    truncated: false,
    disableLinkNavigation: false,
  },
)

const isLink = computed(() => props.as === 'a')
const isRouterLink = computed(() => props.as === 'router-link')

const rootEl = ref<HTMLElement | null>(null)
defineExpose({ ref: rootEl })

function handleItemSelect(
  event: MouseEvent | KeyboardEvent,
  itemId: string | number,
): void {
  if (props.disabled || props.disableLinkNavigation) {
    event.preventDefault()
  }
  if (props.disabled) {
    event.stopPropagation()
    return
  }
  emit('select-item', String(itemId))
}
</script>
